import { Component, OnInit } from '@angular/core';
import { _ } from 'underscore';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  showLogin = true;
  app_url = environment.aap_url;
  constructor(private router: Router) {
   
   }

  ngOnInit() {
    const user = sessionStorage.getItem('userObj');
    if(user)
    {
      this.showLogin = false;
    }
  }

  movetoLogin(){
    sessionStorage.clear();
  }

  gotoProfile(){
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      this.showLogin = false;
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if(result.hg_accountId){
        this.router.navigate(['user-settings', result.hg_accountId]);
      }else{
      this.router.navigate(['user-settings', result._id]);
      }
    }
    
  }

  clearsession(){
    sessionStorage.clear();
  }

  faquss(){
    sessionStorage.setItem('faqFlag','faq');
    sessionStorage.removeItem('contcusFlag');

  }

  contactuss(){
    sessionStorage.setItem('contcusFlag','contact');
    sessionStorage.removeItem('faqFlag');
  }

  addClass($event) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list.png';
    } else {
      elementObj.classList.remove('closeicn');
      elementObj.classList.add('listicn');
      elementObj['src'] = 'assets/images/close.svg';
    }
  }
  mobhead($event) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    const navheadElement = document.getElementById('navbarhead');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list.png';
      navElement.classList.remove('show');
      navheadElement.classList.remove('parent');
    }
  }
}
